/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_steps_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Doručeno`
};

const da_order_steps_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Leveret`
};

const de_order_steps_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Zugestellt`
};

const en_order_steps_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Delivered`
};

const es_order_steps_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Entregado`
};

const fr_order_steps_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Livrée`
};

const hu_order_steps_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Leszállítva`
};

const it_order_steps_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Consegnato`
};

const nl_order_steps_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Geleverd`
};

const pl_order_steps_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Dostarczono`
};

const pt_order_steps_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Entregue`
};

const sv_order_steps_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Levererad`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_steps_delivered = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_steps_delivered(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_steps_delivered", locale)
	if (locale === "cs") return cs_order_steps_delivered(inputs)
	if (locale === "da") return da_order_steps_delivered(inputs)
	if (locale === "de") return de_order_steps_delivered(inputs)
	if (locale === "en") return en_order_steps_delivered(inputs)
	if (locale === "es") return es_order_steps_delivered(inputs)
	if (locale === "fr") return fr_order_steps_delivered(inputs)
	if (locale === "hu") return hu_order_steps_delivered(inputs)
	if (locale === "it") return it_order_steps_delivered(inputs)
	if (locale === "nl") return nl_order_steps_delivered(inputs)
	if (locale === "pl") return pl_order_steps_delivered(inputs)
	if (locale === "pt") return pt_order_steps_delivered(inputs)
	return sv_order_steps_delivered(inputs)
};
export { order_steps_delivered as "order_steps.delivered" }